import { EnumSchema } from '../metadata-schema';

export const DoorstroomStatus: EnumSchema = {
	"type": "string",
	"title": "DoorstroomStatus",
	"enum": [
		"Informatie volledig",
		"Examenstatus niet correct in systeem",
		"(Advies)plaatsing volgend schooljaar nog niet bekend",
		"Doorstroom niet af te leiden uit vertrekstatus",
		"Onbekende doorstroom",
		"Doorstroom kan door onbekende oorzaak niet worden bepaald"
	]
};
